import React from 'react';
import { Box, Button, ButtonMode, ButtonSize, Link } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { SupportPageTileProps } from '@epi-models/pages/Support';
import employerGuideThumbnail from '@epi-assets/images/employer-guide_thumbnail.jpg';
import beneficiaryGuideThumbnail from '@epi-assets/images/beneficiary-guide_thumbnail.jpg';

const guideImages: Record<string, string> = {
  'employer-guide': employerGuideThumbnail,
  'beneficiary-guide': beneficiaryGuideThumbnail
};

const formatVideoDuration = (durationSeconds: number) => {
  const minutes = Math.floor(durationSeconds / 60);
  const seconds = durationSeconds % 60;

  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

export const SupportTiles = (props: SupportPageTileProps) => {
  const { gray50, gray70, fontSemiBold } = useTheme();
  const { t } = useTranslation();
  const { name, url, id } = props;

  return (
    <Box width="100%">
      {props.type === 'video' ? (
        <>
          <Box
            position="relative"
            width="100%"
            paddingBottom="56.25%"
            height={0}
            overflow="hidden"
            id={`support-page-video-${id}`}
          >
            <iframe
              src={`https://www.youtube.com/embed/${url}`}
              title={name}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 0
              }}
            />
          </Box>
          <Box>
            <Box fontWeight={fontSemiBold} mb={0.5} mt={2}>
              {name}
            </Box>
            <Box color={gray50}>
              {formatVideoDuration(props.durationSeconds)}
            </Box>
          </Box>
        </>
      ) : (
        <Box id={`support-page-guide-${id}`}>
          <img
            src={guideImages[props.image]}
            alt={name}
            width="100%"
            id={`support-page-guide-image-${id}`}
          />
          <Box fontWeight={fontSemiBold} my={2}>
            {name}
          </Box>
          <Box color={gray70} mb={2}>
            {props.description}
          </Box>
          <Button
            mode={ButtonMode.Secondary}
            id={`support-page-guide-button-${id}`}
            size={ButtonSize.Small}
          >
            <Link target="_blank" href={url}>
              {t('containers.help.guides.open_button')}
            </Link>
          </Button>
        </Box>
      )}
    </Box>
  );
};
